module.exports = __webpack_public_path__ + "img/KSC08768.6a733864.jpg";